export default __webpack_public_path__ + "static/media/safekit.76a942ef.png";